
<div
	class="env-app-card-container"
	:tabindex="tabindex"
	:state="state"
	:compact="compact"
	@click.stop="handleClick($event)"
>
	<div v-if="!compact" class="env-app-card-header">
		<h6 class="fw-normal fc-dark">
			{{ title }}
		</h6>
		<Icon
			v-if="actionIcon"
			:name="actionIcon"
			type="filled"
			size="small"
			:effects="false"
			:state="state.split('-')[0]"
			@click="action($event)"
		/>
	</div>
	<div class="env-app-card-body">
		<slot />
	</div>
</div>
